import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './SalesDashboard.css';
import TabComponent from './TabComponent/TabComponent';
import SalesCards from './SalesCards/SalesCards';
import OverviewChart from './OverviewChart/OverviewChart';
import RecentSales from './RecentSales/RecentSales';
import Header from './Header/Header';
import IndiaSalesMap from './IndiaSalesMap/SalesMap';
import SalesMap from './IndiaSalesMap/SalesMap';
import TopCustomers from './TopCustomers/TopCustomers';
import DonutPieChart from './DonutPieChart/DonutPieChart';

const SalesDashboard = () => {
    const [activeTab, setActiveTab] = useState('Overall');

    return (
        <div className='sales-dashboard'>
            <Header />
            <br />
            <Container className="">
                <div className='d-flex justify-content-between'>
                    <h1 className='dashboard-title mb-2'>Demo Dashboard</h1>
                    <div>
                        <button className='sales-download-button'>Download</button>
                    </div>
                </div>
                <div className='mb-4'>
                    <TabComponent activeTab={activeTab} setActiveTab={setActiveTab} />
                </div>
                <div className='mb-3'>
                    <SalesCards activeTab={activeTab} />
                </div>
                <div className='mb-3'>
                    <Row>
                        <Col lg={7} md={12} sm={12} style={{ paddingRight: '' }}><OverviewChart activeTab={activeTab} /></Col>
                        <Col lg={5} md={12} sm={12} style={{ paddingLeft: '0.2rem' }}><RecentSales /></Col>
                    </Row>
                </div>
                <div className='mb-3'>
                    <Row>
                        <Col lg={7} md={12} sm={12} style={{ paddingRight: '' }}><DonutPieChart/></Col>
                        {/* <Col lg={7} md={12} sm={12} style={{ paddingRight: '' }}><SalesMap activeTab={activeTab}/></Col> */}
                        <Col lg={5} md={12} sm={12} style={{ paddingLeft: '0.2rem' }}><TopCustomers /></Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default SalesDashboard;